<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M8,4C8,4.6,8.4,5,9,5C9,5,11,5,11,5C11,5,11,7,11,7C11,7.6,11.4,8,12,8C12.6,8,13,7.6,13,7C13,7,13,5,13,5C13,5,15,5,15,5C15.6,5,16,4.6,16,4C16,3.4,15.6,3,15,3C15,3,13,3,13,3C13,3,13,1,13,1C13,0.4,12.6,0,12,0C11.4,0,11,0.4,11,1C11,1,11,3,11,3C11,3,9,3,9,3C8.4,3,8,3.5,8,4C8,4,8,4,8,4C8,4,8,4,8,4ZM14.5,6.5C14.5,6.5,14.5,7,14.5,7C14.5,8.4,13.4,9.5,12,9.5C10.6,9.5,9.5,8.4,9.5,7C9.5,7,9.5,6.5,9.5,6.5C9.5,6.5,9,6.5,9,6.5C7.6,6.5,6.5,5.4,6.5,4C6.5,2.6,7.6,1.5,9,1.5C9,1.5,9.5,1.5,9.5,1.5C9.5,1.5,9.5,1,9.5,1C9.5,0.7,9.6,0.4,9.6,0.2C9.1,0.1,8.6,0,8,0C3.6,0,0,3.6,0,8C0,12.4,3.6,16,8,16C12.4,16,16,12.4,16,8C16,7.4,15.9,6.7,15.8,6.1C15.4,6.4,15,6.5,14.5,6.5C14.5,6.5,14.5,6.5,14.5,6.5C14.5,6.5,14.5,6.5,14.5,6.5Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'NewObject',
} as DefineComponent
</script>
